export default __webpack_public_path__ + "static/media/step_01.f5e1c6ac.png";